module.exports = __webpack_public_path__ + "03fa6f9e7a1e8bf82b0b31093b75f520.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folders_person.png
// module id = 11
// module chunks = 0 1 2 3 4